var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.83 1.77C28.022 2.20065 28.0237 18.7732 27.83 19.23L18.78 10.5C21.1984 8.171 25.8444 3.684 27.83 1.77ZM17.34 11.89C16.9374 12.3996 16.4245 12.8114 15.84 13.0945C15.2555 13.3776 14.6145 13.5247 13.965 13.5247C13.3155 13.5247 12.6745 13.3776 12.09 13.0945C11.5055 12.8114 10.9926 12.3996 10.59 11.89L1.56 20.62C1.75244 20.6718 1.95072 20.6987 2.15 20.7H25.79C25.9893 20.6987 26.1876 20.6718 26.38 20.62L17.34 11.89ZM3.73078e-08 2.46V18.54C-4.29628e-05 18.7744 0.037085 19.0073 0.11 19.23L9.15 10.5C6.55 7.99 2.02 3.61 0.11 1.77C0.037085 1.99274 -4.29628e-05 2.22563 3.73078e-08 2.46ZM1.56 0.380003C4.32 3.05 12.23 10.69 12.47 10.91C12.8673 11.3076 13.4058 11.5319 13.9679 11.5337C14.53 11.5356 15.07 11.315 15.47 10.92C15.7975 10.5669 24.8594 1.87216 26.39 0.390003C26.1955 0.330821 25.9933 0.300498 25.79 0.300003H2.15C1.95072 0.301345 1.75244 0.328231 1.56 0.380003Z",
    fill: "#807CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0efc576ffba1dea79c6f2c31017d6e11.svg";
export { ForwardRef as ReactComponent };